const d = new Date();
const currYear = d.getFullYear();

export default currYear;
